import logo from "../assets/images/logo.svg";
import background from "../assets/images/background.svg";

import { forwardRef } from "react";
function HeaderComponent(
  props: JSX.IntrinsicAttributes,
  ref: React.ForwardedRef<HTMLDivElement>
): JSX.Element {
  return (
    <header className="header" ref={ref} {...props}>
      <aside className="header-aside">
        <img src={logo} alt="Logo" className="header-aside-logo" />
        <h2 className="header-top-text">Hi, I am</h2>
        <div className="header-details-container">
          <h1 className="header-name">Guilherme Puszkarek</h1>
          <p className="header-work">Front-End Developer</p>
        </div>
      </aside>
      <div className="header-content">
        <img
          className="header-background"
          alt="desktop background for header"
          src={background}
          width="100%"
        ></img>
      </div>
    </header>
  );
}
export const Header = forwardRef(HeaderComponent);
